module.exports = "/_next/static/images/Hero-5f48f082d32ba3a9387358099f02cd88.webp";